export enum CpaStatus {
    NOT_REGISTERED = 'not_registered',
    WAIT_REGISTRATION = 'wait_registration',
    TRIAL = 'trial',
    MODERATION = 'moderation',
    ACCEPTED = 'accepted',
    DECLINED = 'declined',
    TRIAL_EXPIRED = 'trial_expired',
    UNKNOWN = 'unknown',
}

export interface WalletInfoDto {
    balance: number;
    is_trial: boolean;
    contract_available?: boolean;
    expire_at?: string;
}

export interface WalletInfoResponseDto {
    wallet_info: WalletInfoDto;
}

export interface WalletInfoModel {
    balance: number;
    isTrial: boolean;
    contractAvailable?: boolean;
    expireAt?: string;
}

export interface CpaState {
    walletInfo?: WalletInfoModel;
    isLoading: boolean;
    attemptCount: number;
    shops: {
        items?: CpaShopModel[];
        isLoading: boolean;
    };
    shopsSuggest: {
        items?: CpaSearchSuggestModel[];
        isLoading: boolean;
    };
    shopsRecomendations: {
        items?: CpaShopModel[];
        isLoading: boolean;
    };
    products: {
        items?: CpaProductModel[];
        isLoading: boolean;
    };
    productsSuggest: {
        items?: CpaSearchSuggestModel[];
        isLoading: boolean;
    };
    productsRecomendations: {
        items?: CpaProductModel[];
        isLoading: boolean;
    };
}

export interface CpaStatusAfterSubmit {
    status: CpaStatus;
}

export interface CpaShopDto {
    url: string;
    badges_info?: {
        badge_type: string;
        text: string;
    }[];
    overall_icon: string;
    shop_description: string;
    shop_name: string;
}

export interface CpaShopsModel {
    items: CpaShopModel[];
}

export interface CpaShopModel {
    url: string;
    badges?: {
        type: string;
        text: string;
    }[];
    icon: string;
    description: string;
    name: string;
}

export interface CpaShopsSuggestDto {
    texts: {
        text: string;
    }[];
    objects: {
        name: string;
        overall_icon?: string;
    }[];
}

export interface CpaSearchSuggestModel {
    text: string;
    icon?: string;
}

export interface CpaProductDto {
    model_name: string;
    image_urls?: string[];
    price?: number;
    cpa_offers: {
        title: string;
        url: string;
        picture: {
            url: string;
        };
        price_info?: {
            currency: string;
            integer_part: number;
        };
    }[];
}

export interface CpaProductsModel {
    items: CpaProductModel[];
}

export interface CpaProductModel {
    name: string;
    image?: string;
    price?: number;
    offers: {
        title: string;
        url: string;
        image: string;
        price?: {
            currency: string;
            integerPart: number;
        };
    }[];
}

export interface CpaProductsSuggestDto {
    texts: {
        text: string;
    }[];
    objects: {
        name: string;
        image?: string;
    }[];
}
